import styled from 'styled-components'

import { SubTextStyled } from '@ui/elements/Text/styles/SubTextStyled'

interface IMultiProgressLineStyledProps {
  position: number
}

export const MultiProgressLineStyled = styled.div<IMultiProgressLineStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  position: absolute;
  left: ${(props) => `${props.position}%`};
  bottom: 0;

  width: ${(props) => props.theme.typography.pxToRem(2)};
  height: calc(100% + 0.5em);
  background-color: ${(props) => props.theme.colors.darkGreen};

  ${SubTextStyled} {
    position: absolute;
    bottom: 100%;
    transform: translateX(-50%);
  }
`
